<template>
  <div class="login-header">
    <table>
      <tr>
        <td class="login-header-logo">
          <el-image :src="require('@/assets/images/Sapico.logo.white.png')" />
        </td>
        <td class="login-header-name">
          <h1>SAPICO</h1>
          <h2>{{ t('headers.NavbarTitleDEMO') }}</h2>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import $ from 'jquery'
import { t } from '@/setup/i18n-setup'

export default {
  name: 'SapicoPasswordPageHeader',
  
  setup() {
    return {};
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  created() {

  },
  computed: {

  },
  methods: {
        t,

  },
  watch: {

  }
}
</script>
